import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/images/ever.svg'
import _imports_1 from '@/images/red-packet-cover.png'
import _imports_2 from '@/images/token/acnh.png'
import _imports_3 from '@/images/ever-logo.svg'


const _hoisted_1 = { class: "bg-permaBlack" }
const _hoisted_2 = {
  class: "red-packet mx-auto",
  style: {"padding-top":"128px","max-width":"500px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-full",
    alt: "everVision"
  })
], -1)
const _hoisted_4 = { class: "w-full px-6 mt-20" }
const _hoisted_5 = {
  key: 0,
  class: "text-14px text-center w-full h-full flex flex-col justify-between"
}
const _hoisted_6 = {
  class: "mx-auto",
  style: {"width":"200px"}
}
const _hoisted_7 = { class: "w-full text-center px-5 mt-54px mb-8" }
const _hoisted_8 = {
  key: 1,
  class: "text-center w-full px-3 flex h-full flex-col justify-between"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "font-space-gtotesk-semiBold text-32px text-permaYellow" }
const _hoisted_11 = { class: "text-base text-white" }
const _hoisted_12 = { class: "mt-5 text-12px text-permaWhite2" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "text-12px text-permaWhite2 flex items-center justify-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-top-right mt-0.5" }, null, -1)
const _hoisted_16 = { class: "text-xs mt-1 text-permaWhite1 break-all" }
const _hoisted_17 = {
  key: 1,
  class: "h-full"
}
const _hoisted_18 = { class: "text-base text-white" }
const _hoisted_19 = { class: "text-xl mt-14" }
const _hoisted_20 = { class: "flex mb-8" }
const _hoisted_21 = {
  href: "https://beta.everpay.io",
  target: "_blank",
  class: "w-full mr-5"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Go everPay(Beta) ")
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 0,
  class: "mt-2 text-12px text-permaWhite3"
}
const _hoisted_25 = {
  key: 1,
  class: "mt-2 text-12px text-permaWhite3"
}
const _hoisted_26 = { class: "mt-16" }
const _hoisted_27 = { class: "pb-16" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-6",
  alt: "ever-logo"
}, null, -1)
const _hoisted_29 = { class: "text-white text-opacity-65 mt-4 text-14px" }
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-right text-center ml-0.5",
  style: {"font-weight":"800","height":"11px","width":"24px"}
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  id: "red_packet_success",
  class: "fixed top-20 left-0 w-full"
}, null, -1)

import BtnArea from '@/components/BtnArea.vue'
import Footer from '@/components/Footer.vue'
import Section from '@/components/Navbar/NavbarSection.vue'
import { ref, computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import lottie, { AnimationItem } from 'lottie-web'
import { isProd, defaultRedPacketUUID } from '@/constants'
import { getRedPacketInfo, verifyRedPacketAddress, cliamRedpacket } from '@/libs/api'
import { RedPacketsInfo, ClaimedTx, CliamParams } from '@/libs/types'
import { v4 as uuidv4 } from 'uuid'
import { getEverpay } from '@/libs/everpay/index'
import dayjs from 'dayjs'
import { validValues } from '@/pages/swap/index'
import { permaMessage } from '@/components/Message'
import { getTokenByTag, fromDecimalToUnitBN } from '@/libs/everpay-js/utils/util'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const { t } = useI18n()
const account = computed(() => store.state.account)
const loading = ref(false)
const lottieWeb = ref<AnimationItem | null>(null)
const cliamSuccess = ref(false)
const cliamErr = ref(false)
const route = useRoute()
const tokens = computed(() => store.state.everpayInfo.tokenList)
const showConnectModal = () => {
  store.commit('updateConnectModalVisible', true)
}
const routeUUID = computed(() => route.params.uuid as string)
const tokenSymbol = computed(() => {
  const uuid = Object.keys(redPackInfo.value?.redpackets ?? {}).includes(routeUUID.value) ? routeUUID.value : defaultRedPacketUUID
  const token = redPackInfo.value?.redpackets[uuid].token
  return getTokenByTag(token ?? '', tokens.value)?.symbol ?? ''
})
const tokenAmount = computed(() => {
  if (addressInfo.value) {
    return fromDecimalToUnitBN(addressInfo.value?.amount, addressInfo.value?.tokenDecimals)
  }
  return 0
})

const cliamTime = computed(() => {
  return dayjs(addressInfo.value?.createdAt).format('YYYY.MM.DD HH:mm')
})
const redPackInfo = ref(null as RedPacketsInfo | null)
const addressInfo = ref(null as ClaimedTx | null)
const claim = async () => {
  if (Object.keys(redPackInfo.value?.redpackets ?? {}).length === 0) {
    permaMessage({
      showClose: true,
      message: t('red_packet.error.err_no_redpacket'),
      type: 'error',
      duration: 2000
    })
    return
  }
  const uuid = Object.keys(redPackInfo.value?.redpackets ?? {}).includes(routeUUID.value) ? routeUUID.value : defaultRedPacketUUID
  const { start, end, UUID } = redPackInfo.value?.redpackets[uuid]!
  if (start > dayjs().unix()) {
    permaMessage({
      showClose: true,
      message: t('red_packet.not_start'),
      type: 'warning',
      duration: 2000
    })
    return
  }
  if (end < dayjs().unix()) {
    permaMessage({
      showClose: true,
      message: t('red_packet.event_closed'),
      type: 'warning',
      duration: 2000
    })
    return
  }
  if (addressInfo.value !== null) {
    permaMessage({
      showClose: true,
      message: t('red_packet.no_repeat_claim'),
      type: 'warning',
      duration: 2000
    })
    return
  }
  cliamErr.value = false
  loading.value = true
  const currentDayTime = dayjs().unix()
  const params: CliamParams = {
    redpacketUUID: UUID,
    claimBy: account.value,
    salt: uuidv4().split('-').join(''),
    createdAt: currentDayTime.toString()
  }
  try {
    const { redpackTx } = await getEverpay().signedRedPackTx(params)
    const result = await cliamRedpacket(redpackTx)
    result.createdAt = dayjs.unix(currentDayTime).toISOString()
    addressInfo.value = result
    if (addressInfo.value) {
      getRedPacktInit()
      lottweb()
    }
  } catch (e: any) {
    if (e.message.includes('Error: timeout')) {
      permaMessage({
        showClose: true,
        message: t('red_packet.hot_err'),
        type: 'warning',
        duration: 2000
      })
      cliamErr.value = true
    } else {
      permaMessage({
        showClose: true,
        message: t(`red_packet.error.${e.message}`),
        type: 'error',
        duration: 2000
      })
    }
    loading.value = false
  }
}

watch(() => account.value, async (newVal) => {
  if (redPackInfo.value?.redpackets && newVal) {
    const uuid = Object.keys(redPackInfo.value?.redpackets ?? {}).includes(routeUUID.value) ? routeUUID.value : defaultRedPacketUUID
    const { UUID, end } = redPackInfo.value.redpackets[uuid]
    addressInfo.value = await verifyRedPacketAddress(UUID, account.value)
    if (addressInfo.value !== null || remainRedPackets.value <= 0 || end < dayjs().unix()) {
      cliamSuccess.value = true
    } else {
      cliamSuccess.value = false
    }
  }
})
const remainRedPackets = ref(0)
const remainPrice = ref(0)
const totalPrice = ref(0)
const totalRedPackets = ref(0)
const activityStart = ref(false)
const getRedPacktInit = async () => {
  const result = await getRedPacketInfo()
  const uuid = Object.keys(result.redpackets).includes(routeUUID.value) ? routeUUID.value : defaultRedPacketUUID
  const { decimals, totalAmount, totalCount, remainCount, remainAmount, start } = result.redpackets[uuid]
  totalPrice.value = fromDecimalToUnitBN(totalAmount, decimals).toNumber()
  remainPrice.value = fromDecimalToUnitBN(remainAmount, decimals).toNumber()
  totalRedPackets.value = totalCount
  remainRedPackets.value = remainCount
  activityStart.value = start < dayjs().unix()
  redPackInfo.value = result
}
onMounted(async () => {
  cliamSuccess.value = false
  cliamErr.value = false
  await getRedPacktInit()
  if (account.value) {
    const uuid = Object.keys(redPackInfo.value?.redpackets ?? {}).includes(routeUUID.value) ? routeUUID.value : defaultRedPacketUUID
    const { UUID, end } = redPackInfo.value!.redpackets[uuid]
    addressInfo.value = await verifyRedPacketAddress(UUID, account.value)
    if (addressInfo.value !== null || remainRedPackets.value <= 0 || end < dayjs().unix()) {
      cliamSuccess.value = true
    }
  }
})

const lottweb = () => {
  lottieWeb.value = null
  lottieWeb.value = lottie.loadAnimation({
    container: document.getElementById('red_packet_success') as HTMLElement, // the dom element that will contain the animation
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: 'anima/celebration.json' // the path to the animation json
  })
  lottieWeb.value.addEventListener('DOMLoaded', () => {
    lottieWeb.value?.goToAndPlay(60, true)
    cliamSuccess.value = true
    loading.value = false
  })
  lottieWeb.value.addEventListener('complete', () => {
    lottieWeb.value?.destroy()
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["border border-permaWhite7 bg-permaBlack6 transition-all duration-300 overflow-hidden", cliamSuccess.value ? 'p-0' : 'p-2']),
          style: {"border-radius":"20px","height":"388px"}
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([cliamSuccess.value ? 'pt-10 acnhRedPacket2' : 'pt-88px acnhRedPacket', "relative h-full transition-all duration-300 flex flex-col items-center rounded-2xl"])
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              class: _normalizeClass([!cliamSuccess.value ? 'top-0' : '-top-52', "absolute top-0 left-0 transition-all duration-1000"]),
              alt: "red-packet-cover"
            }, null, 2),
            _createElementVNode("img", {
              src: _imports_2,
              class: _normalizeClass([cliamSuccess.value ? 'w-72px h-72px' : 'w-16 h-16', "rounded-xl z-10 mb-5"]),
              alt: "acnh"
            }, null, 2),
            (!cliamSuccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('red_packet.cover_title')), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('red_packet.cover_msg')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(BtnArea, {
                      class: _normalizeClass([loading.value ? 'bg-permaGreen4 bg-opacity-30' : '', "rounded-xl bg-permaGreen4 active:bg-permaGreen9 text-black"]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (!_unref(account) ? showConnectModal() : claim() ))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(!_unref(account) ? _unref(t)('connect') : loading.value ? _unref(t)('red_packet.claiming') : cliamErr.value ? _unref(t)('red_packet.retry') : _unref(t)('red_packet.claim')), 1)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (addressInfo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(validValues)(_unref(tokenAmount).toString(),2)), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(tokenSymbol)), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(cliamTime)), 1),
                        _createElementVNode("a", {
                          target: "_blank",
                          href: `https://scan${_unref(isProd) ? '' : '-dev'}.everpay.io/tx/${addressInfo.value?.everHash}`,
                          class: "mt-1 mb-5 flex flex-col"
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            _createTextVNode(_toDisplayString(_unref(t)('red_packet.receiv_address')) + " ", 1),
                            _hoisted_15
                          ]),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(addressInfo.value?.ClaimedBy), 1)
                        ], 8, _hoisted_13)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(tokenSymbol)), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('red_packet.next_luck')), 1)
                      ])),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("a", _hoisted_21, [
                      _createVNode(Section, { class: "py-2 w-full text-14px justify-center text-center transition-color border text-permaGreen4 active:text-permaGreen9 border-permaGreen4 active:border-permaGreen9 border-opacity-25" }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("a", {
                      href: `https://app${_unref(isProd) ? '' : '-dev'}.permaswap.network/ACNH-USDC`,
                      target: "_blank",
                      class: "w-full"
                    }, [
                      _createVNode(Section, { class: "py-2 w-full text-14px justify-center text-center transition-color border text-permaGreen4 active:text-permaGreen9 border-permaGreen4 active:border-permaGreen9 border-opacity-25" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('red_packet.experience_swap')), 1)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_23)
                  ])
                ]))
          ], 2)
        ], 2),
        _createElementVNode("div", null, [
          (remainRedPackets.value <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(t)('red_packet.finished',{total:totalRedPackets.value,totalPrice:totalPrice.value,symbolName: _unref(tokenSymbol)})), 1))
            : (activityStart.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(t)('red_packet.no_finished',{num: totalRedPackets.value - remainRedPackets.value,totalRed:totalRedPackets.value,amount: _unref(validValues)((totalPrice.value - remainPrice.value),2) ,totalAmount: totalPrice.value ,symbolName: _unref(tokenSymbol)})), 1))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('red_packet.everVision1')), 1)
            ]),
            _createElementVNode("a", {
              href: `https://everpay.io/`,
              target: "_blank",
              class: "text-14px leading-6 text-permaGreen4 cursor-pointer active:text-permaGreen9 flex items-center mt-1"
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('red_packet.go_ever')) + " ", 1),
              _hoisted_31
            ], 8, _hoisted_30)
          ])
        ])
      ])
    ]),
    _createVNode(Footer, { class: "mt-16" }),
    _hoisted_32
  ]))
}
}

})